/* =====================================================================
   買取実績一覧：新Shopifyストア（CDN）対応版（URLパラメータ拡張版）

   ・URLパラメータで絞り込み済みの状態で開ける
       ?cat=loose            アイテム（ring / necklace / earring / bracelet / charm / brooch / loose / other）
       ?stone=ルビー         石の種類（カンマ区切りで複数可  例: ルビー,サファイア）
       ?mat=K18              素材（カンマ区切りで複数可  例: K18,Pt900）
       ?maker=ティファニー   メーカー
       ?rating=D             状態（シートの「総合評価」。カンマ区切りで複数可  例: D,C）
                             ※画面に絞り込み欄は出さない、URL専用の隠し絞り込み（?cond= でも可）
     例) /pages/purchase?mat=K18
         /pages/purchase?rating=D
         /pages/purchase?cat=ring&rating=C
   ===================================================================== */

/* 画像の読み込み失敗時に次の候補URL（過去開催回数）へ切替 */
window.pfPurImgError = function(imgEl){
  const raw = imgEl.getAttribute('data-fallback') || '';
  const list = raw ? raw.split('|').filter(Boolean) : [];
  if(list.length){
    const next = list.shift();
    imgEl.setAttribute('data-fallback', list.join('|'));
    imgEl.src = next;
  } else {
    const wrap = imgEl.closest('.pf-pur-image-container') || imgEl.closest('.pf-pur-modal-image');
    if(wrap){
      wrap.classList.add('pf-img-fallback');
      wrap.innerHTML = '<div class="pf-pur-img-fallback-icon">写真準備中</div>';
    }
  }
};

function cbInitPurchaseRecordsPage(){
  const PER = 12;
  let visible = PER, list = [];
  /* 状態別（総合評価）。画面には出さず、URLの ?rating= でだけ使う */
  let ratingFilter = [];

  /* ---------- 設定読み込み ---------- */
  const configEl = document.getElementById('pf-pur-config');
  const config = configEl ? JSON.parse(configEl.textContent || '{}') : {};
  const SHEET_CSV_URL = config.SHEET_CSV_URL || '';

  const SHOPIFY_CDN_BASE = config.SHOPIFY_CDN_BASE || 'https://cdn.shopify.com/s/files/1/0996/7311/2868/files/';
  const MAX_ROUND_LOOKBACK = 6;

  const pageRoot    = document.getElementById('js-pur-page'),
        topbar      = document.getElementById('js-pur-topbar'),
        sidebar     = document.getElementById('js-pur-sidebar'),
        grid        = document.getElementById('js-pur-grid'),
        sentinel    = document.getElementById('js-pur-sentinel'),
        tagsBox     = document.getElementById('js-pur-selected-tags'),
        countNum    = document.getElementById('js-pur-count-num'),
        sort        = document.getElementById('js-pur-sort'),
        sortInline  = document.getElementById('js-pur-sort-inline');

  /* ★修正：materials は後から欄を足せるよう let にした */
  const cats        = sidebar.querySelectorAll('.js-pur-cat-check'),
        makerListEl = document.getElementById('js-pur-maker-list'),
        stoneListEl = document.getElementById('js-pur-stone-list');
  let   materials   = sidebar.querySelectorAll('.js-pur-material-check'),
        makers      = makerListEl ? makerListEl.querySelectorAll('.js-pur-maker-check') : [],
        stones      = stoneListEl ? stoneListEl.querySelectorAll('.js-pur-stone-check') : [],
        allChecks   = [...cats, ...materials, ...makers, ...stones];
  const min       = sidebar.querySelector('.js-pur-price-min'),
        max       = sidebar.querySelector('.js-pur-price-max'),
        quickBtns = sidebar.querySelectorAll('.pf-quick-price-btn');

  const toggle       = document.getElementById('js-pur-filter-toggle'),
        toggleInline = document.getElementById('js-pur-filter-toggle-inline'),
        close        = document.getElementById('js-pur-sp-close'),
        apply        = document.getElementById('js-pur-apply'),
        overlay      = document.getElementById('js-pur-overlay'),
        resultCount  = document.getElementById('js-pur-result-count'),
        filterCountEls = document.querySelectorAll('.js-pur-filter-count'),
        clearAllBtn  = document.getElementById('js-pur-clear-all'),
        catTabs      = document.querySelectorAll('.pf-cat-tab');

  /* ---------- 詳細モーダル要素 ---------- */
  const modalOverlay = document.getElementById('js-pur-modal-overlay'),
        modalEl        = document.getElementById('js-pur-modal'),
        modalClose    = document.getElementById('js-pur-modal-close'),
        modalImage    = document.getElementById('js-pur-modal-image'),
        modalDate     = document.getElementById('js-pur-modal-date'),
        modalTitle    = document.getElementById('js-pur-modal-title'),
        modalTags     = document.getElementById('js-pur-modal-tags'),
        modalPrice    = document.getElementById('js-pur-modal-price'),
        modalSpecs    = document.getElementById('js-pur-modal-specs');

  const CAT_LABELS = { ring:'リング', necklace:'ネックレス', earring:'ピアス', bracelet:'ブレスレット', charm:'チャーム', brooch:'ブローチ', loose:'ルース', other:'その他' };

  if(modalOverlay && modalOverlay.parentNode !== document.body){
    document.body.appendChild(modalOverlay);
  }

  /* =================================================================
     CSV取得・パース
     ================================================================= */
  function parseCSV(text){
    const rows = [];
    let row = [], field = '', inQuotes = false;
    for(let i = 0; i < text.length; i++){
      const c = text[i], next = text[i+1];
      if(inQuotes){
        if(c === '"' && next === '"'){ field += '"'; i++; }
        else if(c === '"'){ inQuotes = false; }
        else { field += c; }
      } else {
        if(c === '"'){ inQuotes = true; }
        else if(c === ','){ row.push(field); field = ''; }
        else if(c === '\n'){ row.push(field); rows.push(row); row = []; field = ''; }
        else if(c === '\r'){ /* skip */ }
        else { field += c; }
      }
    }
    if(field.length || row.length){ row.push(field); rows.push(row); }
    return rows.filter(r => r.length > 1 || (r.length === 1 && r[0].trim() !== ''));
  }

  function rowsToObjects(rows){
    if(!rows.length) return [];
    const header = rows[0].map(h => h.trim());
    return rows.slice(1).map(r => {
      const obj = {};
      header.forEach((h, i) => { obj[h] = (r[i] || '').trim(); });
      return obj;
    });
  }

  const SHAPE_TO_CAT = {
    '指輪': 'ring', 'リング': 'ring',
    'ネックレス・ペンダント': 'necklace', 'ネックレス': 'necklace', 'ペンダント': 'necklace',
    'ピアス': 'earring', 'イヤリング': 'earring',
    'ブレスレット': 'bracelet', 'バングル': 'bracelet', 'ブレスレット・バングル（金属製）': 'bracelet',
    'チャーム': 'charm', 'チャーム・トップ': 'charm', 'ペンダントトップ': 'charm',
    'ブローチ': 'brooch',
    'ダイヤ・ルース': 'loose', '色石・ルース': 'loose', 'ルース': 'loose'
  };
  function mapCategory(shape){
    if(SHAPE_TO_CAT[shape]) return SHAPE_TO_CAT[shape];
    if(/ルース|裸石/.test(shape)) return 'loose';
    if(/ブローチ/.test(shape)) return 'brooch';
    return 'other';
  }

  const MATERIAL_PATTERNS = [
    { re: /K\s*24|Ｋ\s*２４/i,  value: 'K24'   },
    { re: /K\s*22|Ｋ\s*２２/i,  value: 'K22'   },
    { re: /K\s*20|Ｋ\s*２０/i,  value: 'K20'   },
    { re: /K\s*18|Ｋ\s*１８/i,  value: 'K18'   },
    { re: /K\s*14|Ｋ\s*１４/i,  value: 'K14'   },
    { re: /K\s*10|Ｋ\s*１０/i,  value: 'K10'   },
    { re: /K\s*9(?!\d)|Ｋ\s*９(?!\d)/i, value: 'K9' },
    { re: /Pt\s*1000|Ｐｔ\s*１０００/i, value: 'Pt1000' },
    { re: /Pt\s*950|Ｐｔ\s*９５０/i, value: 'Pt950' },
    { re: /Pt\s*900|Ｐｔ\s*９００/i, value: 'Pt900' },
    { re: /Pt\s*850|Ｐｔ\s*８５０/i, value: 'Pt850' },
    { re: /Pt|Ｐｔ/i, value: 'Pt' },
    { re: /Au|Ａｕ/i, value: 'Au' },
    { re: /750/,  value: 'K18' },
    { re: /585/,  value: 'K14' }
  ];

  /* =================================================================
     【石の種類】商品名から自動判定（1商品に複数当てはまる）
     ================================================================= */
  const STONE_DEFS = [
    ['ダイヤモンド',   /ダイヤ|ダイア|[Dd]iamond|DIAMOND|メレ|(^|[^A-Za-z])MD(?![A-Za-z])|(^|[^A-Za-z])D\s*[:：]?\s*\d/],
    ['ルビー',         /ルビー|[Rr]uby|RUBY|(^|[^A-Za-z])R[:：]?\d*\.\d/],
    ['サファイア',     /サファイ[アヤ]|[Ss]apphire|SAPPHIRE|(^|[^A-Za-z])S[:：]?\d*\.\d/],
    ['エメラルド',     /エメラルド|[Ee]merald|EMERALD|(^|[^A-Za-z])E[:：]?\d*\.\d/],
    ['パール',         /(^|[^オ])パール|真珠|[Pp]earl|PEARL/],
    ['オパール',       /オパール|[Oo]pal|OPAL/],
    ['アレキサンドライト', /アレキ/],
    ['キャッツアイ',   /キャッツアイ/],
    ['トルマリン',     /トルマリン|[Tt]ourmaline/],
    ['タンザナイト',   /タンザナイト/],
    ['ガーネット',     /ガーネット|[Gg]arnet/],
    ['アメジスト',     /アメ[ジシ]スト|[Aa]methyst/],
    ['シトリン',       /シトリン/],
    ['トパーズ',       /トパーズ|[Tt]opaz/],
    ['ペリドット',     /ペリドット/],
    ['アクアマリン',   /アクアマリン/],
    ['ヒスイ',         /ヒスイ|ひすい|翡翠/],
    ['サンゴ',         /サンゴ|さんご|珊瑚/],
    ['オニキス',       /オニキス|[Oo]nyx/],
    ['ネフライト',     /ネフライト/],
    ['ムーンストーン', /ムーンストーン/]
  ];
  function detectStones(title){
    const t = normalizeText(title).replace(/．/g, '.').replace(/：/g, ':');
    const out = [];
    STONE_DEFS.forEach(([label, re]) => { if(re.test(t)) out.push(label); });
    return out;
  }

  function normalizeText(s){
    return (s || '').replace(/[Ａ-Ｚａ-ｚ０-９]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0));
  }

  function cleanTitle(raw){
    let t = normalizeText(raw || '');
    t = t.replace(/．/g, '.').replace(/(\d)[,，](\d{3})/g, '$1$2');
    t = t.replace(/D計?[\d.]+ct/gi, '').replace(/[\d.]+(?:[／\/][\d.]+)+g?/g, '');
    t = t.replace(/[\d.]+\s*ct/gi, '').replace(/[\d.]+\s*カラット/g, '');
    t = t.replace(/[\d.]+\s*g(?![a-zA-Z])/gi, '').replace(/[\d.]+\s*号/g, '');
    t = t.replace(/[＃#]\s*[\d.]+/g, '').replace(/(全長|チェーン)?約?[\d.]+\s*(cm|ｃｍ|mm|㎜|ミリ)/gi, '');
    t = t.replace(/[\d.]+\s*刻印/g, '').replace(/[\d.]+\s*[%％]/g, '');
    t = t.replace(/D[:：]?\s*[\d.]+/gi, '').replace(/総重量|全長|チェーン約|刻印|サイズ約|約/g, '');
    t = t.replace(/(^|[\s／\/])D(?=[\s／\/]|$)/g, '$1');
    t = t.replace(/[／\/：:]+/g, ' ').replace(/[ \u00a0\u3000]+/g, ' ').replace(/^[\s、,，・.]+|[\s、,，・.]+$/g, '');
    return t.trim() || raw;
  }

  function guessMaterial(title, maker){
    const t = normalizeText(title) + ' ' + normalizeText(maker || '');
    for(const p of MATERIAL_PATTERNS){ if(p.re.test(t)) return p.value; }
    return '';
  }

  function makerLabel(raw){
    const t = normalizeText(raw || '').trim();
    if(!t || /no\s*brand/i.test(t)) return 'ノーブランド';
    if(/^others?$/i.test(t)) return 'その他ブランド';
    return t;
  }

  function normalizeDate(raw){
    const s = (raw || '').replace(/[^\d]/g, '');
    if(s.length === 8) return s.slice(0,4) + '-' + s.slice(4,6) + '-' + s.slice(6,8);
    if(/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    return raw;
  }

  /* =================================================================
     【画像URL生成】新Shopify CDN 用の画像URL候補を自動作成
     ================================================================= */
  function buildImageCandidates(kaisai, uketsuke){
    if(!uketsuke) return [];

    const kaisaiNum = parseInt(kaisai, 10) || 0;
    const prefixMatch = uketsuke.match(/^(\d+)-/);
    const prefixNum = prefixMatch ? parseInt(prefixMatch[1], 10) : kaisaiNum;

    let hi = Math.max(kaisaiNum, prefixNum);
    let lo = Math.min(kaisaiNum, prefixNum);
    if(hi - lo > MAX_ROUND_LOOKBACK) lo = hi - MAX_ROUND_LOOKBACK;

    const candidates = [];
    const seen = new Set();
    const baseUrl = SHOPIFY_CDN_BASE.endsWith('/') ? SHOPIFY_CDN_BASE : SHOPIFY_CDN_BASE + '/';

    for(let k = hi; k >= lo; k--){
      if(seen.has(k)) continue;
      seen.add(k);
      candidates.push(`${baseUrl}J${k}_${uketsuke}_01L.jpg`);
    }

    return candidates;
  }

  function rowToItem(row, idx){
    const title    = row['商品名'] || '';
    const maker    = row['メーカー'] || '';
    const shape    = row['形状'] || '';
    const priceStr = (row['結果価格'] || '0').replace(/[^\d]/g, '');
    const price    = parseInt(priceStr, 10) || 0;
    const date     = normalizeDate(row['開催日']);
    const kaisai   = (row['開催回数'] || '').trim();
    const uketsuke = (row['受付番号'] || '').trim();
    const rating   = (row['総合評価'] || '').trim();
    const material = guessMaterial(title, maker);
    const makerName = makerLabel(maker);
    const stoneList = detectStones(title);

    const tags = [];
    if(material) tags.push(material);
    if(shape) tags.push(shape);

    const cleanedTitle = cleanTitle(title);
    const imgCandidates = buildImageCandidates(kaisai, uketsuke);

    return {
      id: uketsuke || ('row-' + idx),
      title: cleanedTitle,
      type: mapCategory(shape),
      rawShape: shape.trim() || 'その他',
      material: material,
      stones: stoneList,
      maker: makerName,
      price: price,
      date: date,
      rating: rating,
      imgCandidates: imgCandidates,
      img: imgCandidates[0] || '',
      tags: tags
    };
  }

  /* ---------- 絞り込み・ソートロジック ---------- */
  function vals(){
    return {
      cat:      [...cats].filter(x=>x.checked).map(x=>x.value),
      material: [...materials].filter(x=>x.checked).map(x=>x.value),
      maker:    [...makers].filter(x=>x.checked).map(x=>x.value),
      stone:    [...stones].filter(x=>x.checked).map(x=>x.value),
      rating:   ratingFilter.slice(),
      min: min.value.trim() ? +min.value : null,
      max: max.value.trim() ? +max.value : null
    };
  }
  function hit(i, v, exclude){
    return (exclude==='price'    || ((v.min===null||i.price>=v.min) && (v.max===null||i.price<=v.max)))
        && (exclude==='cat'      || !v.cat.length      || v.cat.includes(i.type))
        && (exclude==='material' || !v.material.length || v.material.includes(i.material))
        && (exclude==='maker'    || !v.maker.length    || v.maker.includes(i.maker))
        && (exclude==='stone'    || !v.stone.length    || v.stone.some(s => i.stones.includes(s)))
        && (exclude==='rating'   || !v.rating.length   || v.rating.includes(normalizeText(i.rating).toUpperCase()));
  }

  let ALL_PRODUCTS = [];

  function countFacet(type, value){
    const v = vals();
    return ALL_PRODUCTS.filter(i => hit(i, v, type) && (
      type==='cat'      ? i.type===value :
      type==='material' ? i.material===value :
      type==='stone'    ? i.stones.includes(value) :
                          i.maker===value
    )).length;
  }

  function counts(){
    [['cat', cats], ['material', materials], ['maker', makers], ['stone', stones]].forEach(([type, cs]) => {
      let anyVisible = false;
      cs.forEach(c => {
        const w = c.closest('.pf-filter-check'), lab = w?.querySelector('.pf-check-label');
        if(!lab) return;
        const base = lab.dataset.base || lab.textContent.trim().replace(/（\d+）$/,'');
        lab.dataset.base = base;
        const n = countFacet(type, c.value);
        lab.innerHTML = base + '<span class="pf-count-num">（' + n + '）</span>';
        const hide = n === 0 && !c.checked;
        w.classList.toggle('is-na', hide);
        if(!hide) anyVisible = true;
      });
      const group = cs.length ? cs[0].closest('.pf-filter-group') : null;
      if(group) group.classList.toggle('is-eg', !anyVisible);
    });

    const checkedCats = [...cats].filter(x=>x.checked).map(x=>x.value);
    catTabs.forEach(t => {
      const v = t.dataset.cat;
      if(v === '') return;
      t.classList.toggle('is-na', countFacet('cat', v) === 0 && !checkedCats.includes(v));
    });

    const v = vals();
    quickBtns.forEach(b => {
      const base = b.dataset.base || b.textContent.trim().replace(/（\d+）$/,'');
      b.dataset.base = base;
      const a = b.dataset.min, bx = b.dataset.max;
      const n = ALL_PRODUCTS.filter(i => hit(i, v, 'price') && (a===''||i.price>=+a) && (bx===''||i.price<=+bx)).length;
      b.textContent = base + '（' + n + '）';
      b.classList.toggle('is-na', n === 0 && !b.classList.contains('is-active'));
    });
  }

  function badge(g, n){
    const b = sidebar.querySelector('.pf-filter-badge[data-group="' + g + '"]');
    if(b){ b.textContent = n || ''; b.classList.toggle('is-visible', !!n) }
  }
  function badges(){
    badge('cat', [...cats].filter(x=>x.checked).length);
    badge('material', [...materials].filter(x=>x.checked).length);
    badge('maker', [...makers].filter(x=>x.checked).length);
    badge('stone', [...stones].filter(x=>x.checked).length);
    badge('price', (min.value || max.value) ? 1 : 0);
  }

  function selected(){
    tagsBox.innerHTML = '';
    const f = document.createDocumentFragment();
    function chip(label, fn){
      const c = document.createElement('span');
      c.className = 'pf-selected-tag-chip';
      c.innerHTML = '<span class="pf-tag-label"></span><button type="button" class="pf-tag-remove">✕</button>';
      c.querySelector('.pf-tag-label').textContent = label;
      c.querySelector('button').onclick = fn;
      f.appendChild(c);
    }
    if(min.value || max.value){
      chip(min.value && max.value ? '¥'+(+min.value).toLocaleString()+'〜¥'+(+max.value).toLocaleString()
           : min.value ? '¥'+(+min.value).toLocaleString()+'〜'
           : '〜¥'+(+max.value).toLocaleString(),
           () => { min.value=''; max.value=''; quickBtns.forEach(b=>b.classList.remove('is-active')); applyFilters() });
    }
    /* 状態別（URLで指定されたときだけ表示。✕で解除できる） */
    if(ratingFilter.length){
      chip('状態' + ratingFilter.join('・'), () => { ratingFilter = []; applyFilters() });
    }
    allChecks.filter(x=>x.checked).forEach(x => {
      const lab = x.closest('.pf-filter-check').querySelector('.pf-check-label');
      const text = (lab.dataset.base || lab.textContent).replace(/（\d+）$/,'');
      chip(text, () => { x.checked = false; applyFilters() });
    });
    tagsBox.appendChild(f);
  }

  function syncCatTabs(){
    const checked = [...cats].filter(x=>x.checked).map(x=>x.value);
    catTabs.forEach(t => {
      const v = t.dataset.cat, isAll = v === '';
      const active = isAll ? checked.length === 0 : (checked.length === 1 && checked[0] === v);
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function esc(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;') }
  function isNew(item){ return item.date && (Date.now() - new Date(item.date).getTime()) / 86400000 <= 7 }

  function buildCardHTML(p){
    const cands = p.imgCandidates && p.imgCandidates.length ? p.imgCandidates : (p.img ? [p.img] : []);
    const first = cands[0] || '';
    const rest = cands.slice(1).join('|');
    const img = first
      ? '<img src="'+esc(first)+'" data-fallback="'+esc(rest)+'" alt="'+esc(p.title)+'" loading="lazy" onerror="pfPurImgError(this)">'
      : '<div class="pf-pur-img-fallback-icon">写真準備中</div>';
    const nw  = isNew(p) ? '<span class="pf-badge-new">NEW</span>' : '';
    const wm  = '<span class="pf-pur-watermark">買取実績</span>';
    const tags = (p.tags||[]).filter(Boolean).map(t => '<span class="pf-pur-info-tag">'+esc(t)+'</span>').join('');
    const tagsHtml = tags ? '<div class="pf-pur-info-tags">'+tags+'</div>' : '';
    const dateLabel = p.date ? p.date.replace(/-/g,'.') : '';
    const ratingHtml = p.rating ? '<span class="pf-pur-rating-badge">'+esc(p.rating)+'</span>' : '<span></span>';
    const bottomBar = (dateLabel || p.rating)
      ? '<div class="pf-pur-image-bottom">' + ratingHtml + (dateLabel ? '<span class="pf-pur-img-date">' + dateLabel + '</span>' : '<span></span>') + '</div>'
      : '';
    return '<div class="pf-pur-card">' +
             '<div class="pf-pur-image-container">' + img + wm + nw + bottomBar +
             '</div>' +
             '<div class="pf-pur-detail">' +
               '<p class="pf-pur-name" title="' + esc(p.title) + '">' + esc(p.title) + '</p>' + tagsHtml +
               '<p class="pf-pur-price"><span class="pf-price-sub">買取価格</span><span class="pf-price-num">' + p.price.toLocaleString() + '</span>円</p>' +
             '</div>' +
           '</div>';
  }

  let scrollLockCount = 0;
  function lockScroll(){ scrollLockCount++; document.body.style.overflow = 'hidden'; }
  function unlockScroll(){ scrollLockCount = Math.max(0, scrollLockCount - 1); if(scrollLockCount === 0) document.body.style.overflow = ''; }

  function openModal(item){
    if(!item || !modalOverlay) return;
    modalImage.className = 'pf-pur-modal-image';
    const modalRatingHtml = item.rating ? '<span class="pf-pur-rating-badge pf-pur-modal-rating">'+esc(item.rating)+'</span>' : '';
    const cands = item.imgCandidates && item.imgCandidates.length ? item.imgCandidates : (item.img ? [item.img] : []);
    const first = cands[0] || '';
    const rest = cands.slice(1).join('|');
    modalImage.innerHTML = (first
      ? '<img src="'+esc(first)+'" data-fallback="'+esc(rest)+'" alt="'+esc(item.title)+'" onerror="pfPurImgError(this)">'
      : '<div class="pf-pur-img-fallback-icon">写真準備中</div>') + modalRatingHtml;
    modalDate.textContent = item.date ? item.date.replace(/-/g,'.') : '';
    modalTitle.textContent = item.title;
    const tagsHtml = (item.tags||[]).filter(Boolean).map(t => '<span class="pf-pur-info-tag">'+esc(t)+'</span>').join('');
    modalTags.innerHTML = tagsHtml;
    modalPrice.textContent = item.price.toLocaleString();

    const specs = [['カテゴリ', CAT_LABELS[item.type] || 'その他']];
    if(item.stones && item.stones.length) specs.push(['石', item.stones.join('・')]);
    if(item.maker && item.maker !== 'ノーブランド') specs.push(['メーカー', item.maker]);
    if(item.material) specs.push(['素材', item.material]);
    modalSpecs.innerHTML = specs.map(([k,v]) =>
      '<div class="pf-pur-modal-spec-row"><dt>'+esc(k)+'</dt><dd>'+esc(v)+'</dd></div>'
    ).join('');

    modalOverlay.classList.add('is-open');
    lockScroll();
    modalClose?.focus();
  }

  function closeModal(){
    if(!modalOverlay || !modalOverlay.classList.contains('is-open')) return;
    modalOverlay.classList.remove('is-open');
    unlockScroll();
  }
  modalClose?.addEventListener('click', closeModal);
  modalOverlay?.addEventListener('click', e => { if(e.target === modalOverlay) closeModal(); });
  document.addEventListener('keydown', e => { if(e.key === 'Escape') closeModal(); });

  const domCache = new Map();
  function ensureEmptyEl(){
    let empty = grid.querySelector('.pf-no-products');
    if(!empty){
      empty = document.createElement('div');
      empty.className = 'pf-no-products';
      empty.innerHTML = '<p>該当する実績が見つかりませんでした。</p><button type="button" id="js-pur-clear-all-inline" class="pf-clear-all-inline">絞り込みをすべて解除する</button>';
      grid.appendChild(empty);
    }
    return empty;
  }

  function render(ps){
    const keepIds = new Set(ps.map(p => String(p.id)));
    ps.forEach((p, idx) => {
      let d = domCache.get(p.id);
      if(!d){
        d = document.createElement('div');
        d.className = 'pf-pur-item';
        d.dataset.pid = p.id;
        d.tabIndex = 0;
        d.setAttribute('role', 'button');
        d.setAttribute('aria-haspopup', 'dialog');
        d.innerHTML = buildCardHTML(p);
        domCache.set(p.id, d);
        grid.appendChild(d);
      }
      d.style.order = idx;
      d.style.display = '';
    });
    domCache.forEach((d, id) => { if(!keepIds.has(String(id))) d.style.display = 'none' });
    if(!ps.length){ ensureEmptyEl().style.display = 'flex' }
    else { const empty = grid.querySelector('.pf-no-products'); if(empty) empty.style.display = 'none' }
  }

  function clearAll(){
    allChecks.forEach(x => x.checked = false);
    min.value = ''; max.value = '';
    ratingFilter = [];
    quickBtns.forEach(b => b.classList.remove('is-active'));
    applyFilters();
  }

  function buildMakerFacet(){
    if(!makerListEl) return;
    const makerCounts = new Map();
    ALL_PRODUCTS.forEach(p => { makerCounts.set(p.maker, (makerCounts.get(p.maker) || 0) + 1) });
    const entries = [...makerCounts.entries()].sort((a, b) => {
      if(a[0] === 'ノーブランド') return 1;
      if(b[0] === 'ノーブランド') return -1;
      if(a[0] === 'その他ブランド') return 1;
      if(b[0] === 'その他ブランド') return -1;
      return b[1] - a[1];
    });
    makerListEl.innerHTML = entries.map(([name]) =>
      '<label class="pf-filter-check"><input type="checkbox" value="' + esc(name) + '" class="js-pur-maker-check">' +
      '<span class="pf-checkbox-box"></span><span class="pf-check-label">' + esc(name) + '</span></label>'
    ).join('');
    makers = makerListEl.querySelectorAll('.js-pur-maker-check');
    allChecks = [...cats, ...materials, ...makers, ...stones];
    makers.forEach(x => x.addEventListener('change', () => applyFilters()));
    const group = makerListEl.closest('.pf-filter-group');
    if(group) group.classList.toggle('is-eg', entries.length === 0);
  }

  function buildStoneFacet(){
    if(!stoneListEl) return;
    const stoneCounts = new Map();
    ALL_PRODUCTS.forEach(p => p.stones.forEach(s => stoneCounts.set(s, (stoneCounts.get(s) || 0) + 1)));
    const entries = [...stoneCounts.entries()].sort((a, b) => b[1] - a[1]);
    stoneListEl.innerHTML = entries.map(([name]) =>
      '<label class="pf-filter-check"><input type="checkbox" value="' + esc(name) + '" class="js-pur-stone-check">' +
      '<span class="pf-checkbox-box"></span><span class="pf-check-label">' + esc(name) + '</span></label>'
    ).join('');
    stones = stoneListEl.querySelectorAll('.js-pur-stone-check');
    allChecks = [...cats, ...materials, ...makers, ...stones];
    stones.forEach(x => x.addEventListener('change', () => applyFilters()));
    const group = stoneListEl.closest('.pf-filter-group');
    if(group) group.classList.toggle('is-eg', entries.length === 0);
  }

  /* 素材の欄がサイドバーに無い値は、チェック欄を自動で足す */
  function ensureMaterial(value){
    let el = [...materials].find(x => x.value === value);
    if(el) return el;
    const first = materials[0];
    const wrap = first && first.closest('.pf-filter-check');
    if(!wrap) return null;
    const lab = document.createElement('label');
    lab.className = 'pf-filter-check';
    lab.innerHTML = '<input type="checkbox" value="' + esc(value) + '" class="js-pur-material-check">' +
      '<span class="pf-checkbox-box"></span><span class="pf-check-label">' + esc(value) + '</span>';
    wrap.parentNode.appendChild(lab);
    materials = sidebar.querySelectorAll('.js-pur-material-check');
    allChecks = [...cats, ...materials, ...makers, ...stones];
    el = lab.querySelector('input');
    el.addEventListener('change', () => applyFilters());
    return el;
  }

  /* URLパラメータで絞り込み済みの状態にする
     例) ?cat=loose&stone=ルビー  ?mat=K18  ?mat=K18,Pt900  ?maker=ティファニー  ?rating=D */
  function applyUrlParams(){
    let q;
    try{ q = new URLSearchParams(location.search); }catch(e){ return; }
    const c = q.get('cat'), s = q.get('stone'), m = q.get('mat'), mk = q.get('maker');
    const rt = q.get('rating') || q.get('cond');
    const openGroup = el => {
      const d = el && el.closest('details'); if(d) d.open = true;
      const g = el && el.closest('.pf-filter-group'); if(g) g.classList.add('is-open');
    };
    if(c) cats.forEach(x => { x.checked = (x.value === c) });
    if(s){
      const sl = s.split(',').map(v => v.trim());
      stones.forEach(x => { x.checked = sl.includes(x.value); if(x.checked) openGroup(x); });
    }
    if(m){
      const ml = m.split(',').map(v => v.trim()).filter(v => /^(K\d+|Pt\d*|Au)$/.test(v));
      ml.forEach(v => {
        const el = ensureMaterial(v);
        if(el){ el.checked = true; openGroup(el); }
      });
    }
    if(mk){
      makers.forEach(x => { if(x.value.toLowerCase() === mk.toLowerCase()){ x.checked = true; openGroup(x); } });
    }
    /* 状態別（総合評価）：A〜Fなどの1文字。カンマ区切りで複数可 */
    if(rt){
      ratingFilter = rt.split(',')
        .map(v => normalizeText(v).trim().toUpperCase())
        .filter(v => /^[A-Z]$/.test(v));
    }
  }

  grid.addEventListener('click', e => {
    if(e.target.closest('#js-pur-clear-all-inline')){ clearAll(); return; }
    const card = e.target.closest('.pf-pur-item');
    if(card){
      const item = ALL_PRODUCTS.find(p => String(p.id) === String(card.dataset.pid));
      if(item) openModal(item);
    }
  });

  grid.addEventListener('keydown', e => {
    if(e.key !== 'Enter' && e.key !== ' ') return;
    const card = e.target.closest('.pf-pur-item');
    if(!card) return;
    e.preventDefault();
    const item = ALL_PRODUCTS.find(p => String(p.id) === String(card.dataset.pid));
    if(item) openModal(item);
  });
  clearAllBtn?.addEventListener('click', clearAll);

  function applyFilters(reset = true){
    counts(); badges(); selected(); syncCatTabs();
    const v = vals();
    list = ALL_PRODUCTS.filter(i => hit(i, v));
    const s = sort.value;
    list.sort((a,b) => s==='price-desc' ? b.price - a.price
                     : s==='price-asc'  ? a.price - b.price
                     : new Date(b.date) - new Date(a.date));
    if(reset) visible = PER;
    visible = Math.min(Math.max(visible, PER), list.length);
    if(countNum) countNum.textContent = list.length;
    if(resultCount) resultCount.textContent = list.length;
    filterCountEls.forEach(el => el.textContent = '（' + list.length + '）');
    render(list.slice(0, visible));
    requestAnimationFrame(loadCheck);
  }

  function more(){
    if(visible >= list.length) return;
    visible = Math.min(visible + PER, list.length);
    render(list.slice(0, visible));
    requestAnimationFrame(loadCheck);
  }

  function loadCheck(){
    if(sentinel && visible < list.length && sentinel.getBoundingClientRect().top <= innerHeight + 600) more();
  }

  const openSidebar = () => { sidebar.classList.add('is-open'); overlay.classList.add('is-open'); lockScroll() };
  const shutSidebar = () => { sidebar.classList.remove('is-open'); overlay.classList.remove('is-open'); unlockScroll() };
  toggle?.addEventListener('click', openSidebar);
  toggleInline?.addEventListener('click', openSidebar);
  close?.addEventListener('click', shutSidebar);
  overlay?.addEventListener('click', shutSidebar);
  apply?.addEventListener('click', () => { shutSidebar(); window.scrollTo({top:0, behavior:'smooth'}) });

  const mqMobile = window.matchMedia('(max-width:900px)');
  const SP_SHOW_THRESHOLD = 50;
  let lastY = window.scrollY;

  /* 新ヘッダー(#kh)が出ている時だけ高さを返す。隠れている時は0（バーを上に詰める） */
  function siteHeaderH(){
    const h = document.getElementById('kh') || document.querySelector('.site-header');
    if(!h || h.classList.contains('is-hide')) return 0;
    return h.offsetHeight;
  }
  function updateTopbarTop(){
    if(topbar && mqMobile.matches) topbar.style.top = (siteHeaderH() + 10) + 'px';
  }
  function onScrollTopbar(){
    if(!topbar) return;
    if(mqMobile.matches){
      updateTopbarTop();
      const y = window.scrollY;
      const inlineToolbar = document.getElementById('js-pur-toolbar-inline');
      const inlineStillVisible = inlineToolbar ? inlineToolbar.getBoundingClientRect().bottom > 0 : false;
      if(y <= SP_SHOW_THRESHOLD || inlineStillVisible) topbar.classList.remove('is-visible');
      else if(y > lastY) topbar.classList.remove('is-visible');
      else if(y < lastY) topbar.classList.add('is-visible');
      lastY = y;
    } else {
      topbar.classList.remove('is-visible');
      topbar.style.top = '';
    }
  }
  addEventListener('scroll', () => requestAnimationFrame(onScrollTopbar), {passive:true});
  addEventListener('resize', () => requestAnimationFrame(onScrollTopbar));
  onScrollTopbar();

  /* ヘッダーの出入り（is-hide の付け外し）に合わせてバーの位置も追従させる */
  const khEl = document.getElementById('kh');
  if(khEl && 'MutationObserver' in window){
    new MutationObserver(updateTopbarTop).observe(khEl, {attributes:true, attributeFilter:['class']});
  }

  allChecks.forEach(x => x.addEventListener('change', () => applyFilters()));
  sort?.addEventListener('change', () => { if(sortInline) sortInline.value = sort.value; applyFilters() });
  sortInline?.addEventListener('change', () => { sort.value = sortInline.value; applyFilters() });
  min.addEventListener('input', applyFilters);
  max.addEventListener('input', applyFilters);

  catTabs.forEach(t => t.addEventListener('click', () => {
    const v = t.dataset.cat;
    if(v === '') cats.forEach(c => c.checked = false);
    else cats.forEach(c => { c.checked = (c.value === v) });
    applyFilters();
  }));

  quickBtns.forEach(b => b.addEventListener('click', () => {
    const wasActive = b.classList.contains('is-active');
    quickBtns.forEach(x => x.classList.remove('is-active'));
    if(wasActive){ min.value = ''; max.value = '' }
    else { min.value = b.dataset.min || ''; max.value = b.dataset.max || ''; b.classList.add('is-active') }
    applyFilters();
  }));

  if('IntersectionObserver' in window){
    new IntersectionObserver(es => es.forEach(e => e.isIntersecting && more()), {rootMargin:'800px 0px'}).observe(sentinel);
  }
  addEventListener('scroll', () => requestAnimationFrame(loadCheck), {passive:true});
  addEventListener('resize', loadCheck);

  function showError(message){
    grid.innerHTML = '<div class="pf-pur-error">' + esc(message) + '</div>';
    if(pageRoot) pageRoot.classList.add('is-pf-ready');
  }

  if(!SHEET_CSV_URL || SHEET_CSV_URL.indexOf('http') !== 0){
    showError('実績データの読み込み先(SHEET_CSV_URL)が設定されていません。テンプレート内の pf-pur-config を確認してください。');
    return;
  }

  fetch(SHEET_CSV_URL, { cache: 'no-store' })
    .then(res => {
      if(!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    })
    .then(text => {
      const rows = parseCSV(text);
      const objs = rowsToObjects(rows);
      ALL_PRODUCTS = objs
        .map((row, idx) => rowToItem(row, idx))
        .filter(item => item.title);

      if(grid){ grid.innerHTML = ''; domCache.clear(); }
      buildMakerFacet();
      buildStoneFacet();
      applyUrlParams();
      applyFilters();
      if(pageRoot) pageRoot.classList.add('is-pf-ready');
    })
    .catch(err => {
      console.error('[purchase-records] CSV読み込みエラー:', err);
      showError('実績データの読み込みに失敗しました。');
    });
}

function cbStartPurchaseRecordsPage(){
  try{ cbInitPurchaseRecordsPage(); }catch(err){
    console.error('[purchase-records] init error:', err);
    const root = document.getElementById('js-pur-page');
    if(root) root.classList.add('is-pf-ready');
  }
}
document.readyState === 'loading'
  ? document.addEventListener('DOMContentLoaded', cbStartPurchaseRecordsPage)
  : cbStartPurchaseRecordsPage();